/* eslint-disable prettier/prettier */
import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    purchaseOrders: {},
    purchaseOrder: {},
    isLoadingTable: false,
    showDeleteModal: false,
    showHistoryLog: false,
    historyLog: ""
}

const mutations = {
    getPaginatedPos(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/purchaseorders/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`).then(response => {
            response.data.data.forEach(d => {
                d.poDate = moment(d.poDate).format('MM/DD/YYYY')
                d.dateCreated = moment(d.dateCreated).format('MM/DD/YYYY HH:mm')
                d.total = numeral(d.total).format('0,0.00')
            })
            state.purchaseOrders = response.data
            // eslint-disable-next-line no-console
        }).catch(error => console.log(error)).then(() => state.isLoadingTable = false)
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.purchaseOrder) {
            state.purchaseOrder = payload.purchaseOrder
        } else {
            state.purchaseOrder = {}
        }
    },
    openHistoryLogModal(state, payload) {
        state.showHistoryLog = payload.showHistoryLog
        if (payload.showHistoryLog) {
            state.historyLog = payload.historyLog
        } else {
            state.historyLog = ""
        }
    }
}

const actions = {
    getPaginatedPos({
        commit
    }, payload) {
        commit('getPaginatedPos', payload)
    },
    openDeleteModal({
        commit
    }, payload) {
        commit('openDeleteModal', payload)
    }, openHistoryLogModal({
        commit
    }, payload) {
        commit('openHistoryLogModal', payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}